app.controller('CheckoutDetailsController', [
  '$scope',
  'Config',
  '$timeout',
  'cart',
  'toaster',
  'product',
  'CacheFactory',
  'quote',
  '$window',
  '$location',
  '$anchorScroll',
  'setting',
  'helper',
  function ($scope, Config, $timeout, cart, toaster, product, CacheFactory, quote, $window, $location, $anchorScroll, setting, helper) {

    $scope.cart = cart.getCart();
    $scope.base_url = Config.base_url;
    $scope.cartService = cart;
    $scope.rates = {};

    $scope.details = {
      name: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').name : '',
      telephone: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').telephone : '',
      company: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').company : '',
      email: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').email : '',
      deliveryPostcode: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').deliveryPostcode : '',
      collectionPostcode: (CacheFactory.get('appCache').get('quote')) ? CacheFactory.get('appCache').get('quote').collectionPostcode : '',
      deliveryDate: (CacheFactory.get('appCache').get('deliveryDate')) ? moment(CacheFactory.get('appCache').get('deliveryDate')).toDate() : moment().add(1, 'days').toDate(),
      collectionDate: (CacheFactory.get('appCache').get('collectionDate')) ? moment(CacheFactory.get('appCache').get('collectionDate')).toDate() : moment().add(7, 'days').toDate(),
      deliveryDateOpened: false,
      collectionDateOpened: false,
      hireDays: (CacheFactory.get('appCache').get('hireDays')) ? CacheFactory.get('appCache').get('hireDays') : 8,
      hireWeeks: (CacheFactory.get('appCache').get('hireWeeks')) ? CacheFactory.get('appCache').get('hireWeeks') : 1,
      deliveryDateOptions: {
        minDate: moment().add(1, 'days').toDate(),
        startingDay: 1
      },
      collectionDateOptions: {
        minDate: moment().add(2, 'days').toDate(),
        startingDay: 1
      },
      limitations: ''
    }


    $scope.init = function () {
      $scope.rates = {
        vatRate: Config.vatRate,
      };
      $anchorScroll.yOffset = 80;
      var hour;
      //get brand setting
      setting.get().then(function (response) {
        //set min delivery and collection dates based on saved cut-off time
        //retrieve 2 digit current hour value from the server
        setting.getTime().then(function (resp) {
            hour = resp.data.hour_24;
            if (hour >= parseInt(response.data.global.cutoff_time)) {
              $scope.details.deliveryDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after), 'days').toDate();
              $scope.details.deliveryDate = (CacheFactory.get('appCache').get('deliveryDate')) ? moment(CacheFactory.get('appCache').get('deliveryDate')).toDate() : moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after), 'days').toDate();
              $scope.details.collectionDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after) + 1, 'days').toDate();
              $scope.details.collectionDate = (CacheFactory.get('appCache').get('collectionDate')) ? moment(CacheFactory.get('appCache').get('collectionDate')).toDate() : moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_after) + 7, 'days').toDate();
            } else {
              $scope.details.deliveryDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before), 'days').toDate();
              $scope.details.deliveryDate = (CacheFactory.get('appCache').get('deliveryDate')) ? moment(CacheFactory.get('appCache').get('deliveryDate')).toDate() : moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before), 'days').toDate();
              $scope.details.collectionDateOptions.minDate = moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before) + 1, 'days').toDate();
              $scope.details.collectionDate = (CacheFactory.get('appCache').get('collectionDate')) ? moment(CacheFactory.get('appCache').get('collectionDate')).toDate() : moment(resp.data.datetime).add(parseInt(response.data.global.min_date_offset_before) + 7, 'days').toDate();
            }
          })
          .catch(function (error) {
            console.log(error);
            // hour = (moment.utc().isDST()) ? moment.utc().utcOffset(60).hour() : moment.utc().hour();
          });
        helper.hideLoader();
      }, function (response) {

      });
    }

    $scope.copyPostcode = function (event) {
      $scope.details.collectionPostcode = $scope.details.deliveryPostcode;
    }

    $scope.freeClickCollect = function (event) {
      event.preventDefault();
      $scope.details.collectionPostcode = $scope.details.deliveryPostcode = 'DA2 6QL';
    }

    $scope.setCol = function () {
      $scope.details.collectionDate = new Date($scope.details.deliveryDate.getFullYear(), $scope.details.deliveryDate.getMonth(), $scope.details.deliveryDate.getDate());
      $scope.details.collectionDate = moment($scope.details.collectionDate).add(1, 'days').toDate();
      $scope.details.collectionDateOptions.minDate = $scope.details.collectionDate;
      $scope.details.collectionDateOpened = true;
      $scope.setHirePeriod();
    }

    $scope.setHirePeriod = function () {

      deliveryDate = new Date($scope.details.deliveryDate.getFullYear(), $scope.details.deliveryDate.getMonth(), $scope.details.deliveryDate.getDate());
      collectionDate = new Date($scope.details.collectionDate.getFullYear(), $scope.details.collectionDate.getMonth(), $scope.details.collectionDate.getDate());
      $scope.details.hireDays = helper.hireDays(deliveryDate, collectionDate);

      if ($scope.details.hireDays == 1) {
        $scope.details.hireWeeks = 1;
      } else {
        $scope.details.hireWeeks = Math.round(($scope.details.hireDays / 7) + 0.35);
      }
      CacheFactory.get('appCache').put('hireDays', $scope.details.hireDays);
      CacheFactory.get('appCache').put('hireWeeks', $scope.details.hireWeeks);
      CacheFactory.get('appCache').put('deliveryDate', moment($scope.details.deliveryDate).utc());
      CacheFactory.get('appCache').put('collectionDate', moment($scope.details.collectionDate).utc());
      $scope.cartService.updateCart();
    }

    $scope.open = function (field) {
      if (field == 'col') {
        $scope.details.collectionDateOpened = true;
      } else {
        $scope.details.deliveryDateOpened = true;
      }
    }

    $scope.remove = function (idx) {
      var product_name = $scope.cart.content[idx].data.product_name;
      cart.remove(idx);
      toaster.pop('success', "Quote Updated!", product_name + ' removed successfully from quote!');
    }

    $scope.getQuote = function (form) {

      $scope.details.limitations = '';
      var content = angular.copy($scope.cart.content);

      //go through cart and add the full link for product images
      angular.forEach(content, function (item, key) {
        item.data.image = item.data.cart_image;
      });

      if (form.$valid) {
        helper.showTransLoader();
        data = {
          'brand': Config.brand_key,
          'delivery-postcode': $scope.details.deliveryPostcode,
          'collection-postcode': $scope.details.collectionPostcode,
          'cart-total-weight': cart.totalWeight(),
          'product-total': cart.getCart().totals.productTotal,
          'company': $scope.details.company,
          'name': $scope.details.name,
          'email': $scope.details.email,
          'telephone': $scope.details.telephone,
          'hire-days': $scope.details.hireDays,
          'hire-weeks': $scope.details.hireWeeks,
          'user-agent': angular.element('#user_agent').val(),
          'user-ip': angular.element('#user_ip').val(),
          'token': angular.element('#user_token').val(),
          'delivery-date-timestamp': moment($scope.details.deliveryDate).utc().unix(),
          'collection-date-timestamp': moment($scope.details.collectionDate).utc().unix(),
          'cart': content
        };

        //check for applied discount codes
        if (angular.isDefined(CacheFactory.get('appCache').get('quote'))) {
          if (angular.isDefined(CacheFactory.get('appCache').get('quote').discountCode)) {
            data['discount-code'] = CacheFactory.get('appCache').get('quote').discountCode;
          }
        }

        if ($('#utm_source').val() != '') {
          data['utm_source'] = $('#utm_source').val();
        }

        if ($('#utm_medium').val() != '') {
          data['utm_medium'] = $('#utm_medium').val();
        }

        if ($('#utm_campaign').val() != '') {
          data['utm_campaign'] = $('#utm_campaign').val();
        }

        if ($('#camefrom').val() != '') {
          data['camefrom'] = $('#camefrom').val();
        }

        //get the delivery and collection timestamps
        quote.get(data).then(function (response) {
          var dataObj = response.data;
          if (typeof dataObj.code === 'undefined') {
            $scope.cart.cartChanged = false;
            CacheFactory.get("appCache").put("cart", $scope.cart);
            CacheFactory.get('appCache').put('quote', response.data);
            //redirect to the quote page
            $window.location.href = $scope.base_url + 'checkout/quote';
          }
        }, function (response) {
          if (response.status == 406) {
            //then there are some limitations
            $scope.details.limitations = response.data.limitations.message;
            helper.hideTransLoader();
          }
        });
      } else {
        // scroll up to the details section
        $location.hash('detailsForm');
        $anchorScroll();
      }
    }

  }
]);
